import { TypedUseSelectorHook, useSelector } from "react-redux";
import { State } from "../state";

export const useCustomSelector: TypedUseSelectorHook<State> = useSelector;
